import { render, staticRenderFns } from "./details_manager.vue?vue&type=template&id=d93ef31a&"
import script from "./details_manager.vue?vue&type=script&lang=js&"
export * from "./details_manager.vue?vue&type=script&lang=js&"
import style0 from "./details_manager.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports